/**
 * Wall-clock time in an IANA timezone → UTC epoch milliseconds.
 *
 * `iso` is `YYYY-MM-DDTHH:mm:ss` with no offset: that clock time in `timeZone`,
 * not the visitor's local zone. Used where a campaign window must match
 * Europe/Amsterdam even though the page HTML can be CDN-cached.
 *
 * Consumed as `window.SamduoZonedTime.stamp`.
 */
(() => {
  const stamp = (iso, timeZone) => {
    const [date, time] = String(iso || '').split('T');
    const [year, month, day] = date.split('-').map(Number);
    const [hour, minute, second] = String(time || '').split(':').map(Number);
    const wall = Date.UTC(year, month - 1, day, hour, minute || 0, second || 0);
    const offset = (instant) => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).formatToParts(new Date(instant));
      const map = Object.fromEntries(parts.filter((part) => part.type !== 'literal').map((part) => [part.type, part.value]));
      const hourValue = map.hour === '24' ? 0 : Number(map.hour);
      return Date.UTC(map.year, Number(map.month) - 1, map.day, hourValue, map.minute, map.second) - instant;
    };
    let value = wall - offset(wall);
    value = wall - offset(value);
    return value;
  };

  window.SamduoZonedTime = { stamp };
})();
